import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Button, {
            'disabled': true,
            'children': 'disabled'
        }),
        _$cc(Button, {
            'disabled': true,
            'type': 'none',
            'children': 'disabled text'
        }),
        _$cc(Button, {
            'disabled': true,
            'icon': true,
            'circle': true,
            'children': (
                _$ce(2, 'i', null, 1, 'k-icon ion-ios-search')
            )
        }),
        _$cc(Button, {
            'disabled': true,
            'type': 'link',
            'children': 'link'
        })
    ], 4);
};